var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"40%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"content"},[_c('el-image',{staticStyle:{"width":"100%"},attrs:{"src":require('@/static/image/inform.png'),"fit":"contain"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }